/**
 * @license
 * @copyright Copyright Motili Inc., 2025 All Rights Reserved
 */

const GUIDE_TOUR_READY_EVENT_NAME = 'GuideTourReady';

let loadPromise: Promise<void> | null = null;

function loadTourScript(src: string, timeoutMs = 10000): Promise<void> {
    return new Promise((resolve, reject) => {
        if (window.__guideTourScriptLoaded) {
            resolve();
            return;
        }

        const script = document.createElement('script');
        script.src = src;
        script.async = true;

        const timeout = setTimeout(
            () => reject(new Error('Script load timed out')),
            timeoutMs
        );

        script.onload = () => {
            clearTimeout(timeout);
            window.__guideTourScriptLoaded = true;
            resolve();
        };

        script.onerror = () => {
            clearTimeout(timeout);
            reject(new Error('Script failed to load'));
        };

        document.body.appendChild(script);
    });
}

function waitUntilTourReady(timeoutMs = 5000): Promise<void> {
    if (window.GuideTour) return Promise.resolve();

    return new Promise((resolve, reject) => {
        const timeout = setTimeout(
            () => reject(new Error('Tour did not signal ready')),
            timeoutMs
        );

        const onReady = () => {
            clearTimeout(timeout);
            window.removeEventListener(GUIDE_TOUR_READY_EVENT_NAME, onReady);
            resolve();
        };

        window.addEventListener(GUIDE_TOUR_READY_EVENT_NAME, onReady);
    });
}

export function preloadTourScript(src: string): Promise<void> {
    if (!loadPromise) {
        loadPromise = loadTourScript(src).then(() => waitUntilTourReady());
    }
    return loadPromise;
}
